import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { getPolicyByEnrollmentPeriodId, triggerAlliedWelcomeLetter } from 'api/operations/policyService';
import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { File } from 'types/policyService';

interface DomainParams {
  enrollmentPeriodId: string;
}

export class WelcomeKitPageStore {
  private _domainParams: DomainParams;
  private _files: File[] = [];
  private _isLoading = false;

  public get files(): File[] {
    return this._files;
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public setLoading(status: boolean): void {
    this._isLoading = status;
  }

  public async getInitialData(): Promise<void> {
    this.setLoading(true);
    const policy = await getPolicyByEnrollmentPeriodId(this._domainParams.enrollmentPeriodId);
    runInAction(() => {
      this._files = policy.filesFromDocx;
      this.setLoading(false);
    });
  }

  public async triggerAlliedWelcomeLetter(): Promise<void> {
    this.setLoading(true);
    await triggerAlliedWelcomeLetter(this._domainParams.enrollmentPeriodId);

    runInAction(() => {
      toastManager.addToast('Welcome letter sent successfully', ToastColorTypes.SUCCESS);
      this.setLoading(false);
    });
  }

  constructor(domainParams: DomainParams) {
    makeAutoObservable(this, {}, { autoBind: true });
    this._domainParams = domainParams;
  }
}

const WelcomeKitPageStoreContext = createContext(new WelcomeKitPageStore({} as DomainParams));

export const useWelcomeKitPageStore = (): WelcomeKitPageStore => {
  return useContext(WelcomeKitPageStoreContext);
};

export { WelcomeKitPageStoreContext };
